import '../../Icon.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs } from "react/jsx-runtime";
import "../../Utilities.js";
import { Icon as Icon$1 } from "@fluentui/react/lib/Icon";
import { WithCallout } from "../Callout/WithCallout.js";
/* empty css                   */import { css } from "@fluentui/utilities";
const defaultClassNameContainer = "ane-Icon-container";
const defaultClassName = "ane-Icon";
const defaultClassTextContainer = "ane-Icon-textContainer";
const getIconWithText = (props, Icon2) => {
  const { onClick } = props;
  return !!onClick ? Icon2 : /* @__PURE__ */ jsx("div", { className: defaultClassNameContainer, children: /* @__PURE__ */ jsxs("div", { className: "flexContainer", children: [
    Icon2,
    /* @__PURE__ */ jsxs("div", { className: defaultClassTextContainer, children: [
      props.text,
      " ",
      props.children
    ] })
  ] }) });
};
const defaultIconStyles = {
  root: {
    paddingTop: "0px",
    paddingRight: "4px",
    paddingBottom: "0px",
    paddingLeft: "4px",
    width: "32px",
    height: "32px",
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "32px",
    boxSizing: "border-box"
  }
};
const Icon = (props) => {
  let _a = props, { className, styles, children } = _a, rest = __objRest(_a, ["className", "styles", "children"]);
  const defaultStyles = __spreadValues(__spreadValues({}, defaultIconStyles), styles);
  const Icon2 = /* @__PURE__ */ jsx(Icon$1, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, className: css(defaultClassName, className) }));
  const IconWrapper = /* @__PURE__ */ jsx(WithCallout, { calloutProps: props.calloutProps, children: Icon2 });
  return getIconWithText(props, IconWrapper);
};
export {
  Icon,
  Icon as default
};
//# sourceMappingURL=Icon.js.map
